export const DEFAULT_SUBMITTED_CARTS_PER_PAGE = 20;
export const DEFAULT_TILLS_PER_PAGE = 999999;
